import EnrollmentError from './EnrollmentError';

class RFCError extends EnrollmentError {
  constructor(code, details = null) {
    super(code, 'RFCError', details);
  }
}

export default RFCError;
